// @packages
import { makeStyles } from '@rneui/themed';

export default makeStyles((theme) => ({
  container: {
    width: '100%',
    maxWidth: 500
  },
  titleText: {
    color: theme.colors.primary,
    fontSize: 15,
    fontWeight: 'bold',
    marginBottom: 10,
    marginHorizontal: 5,
    textAlign: 'center'
  },
  textCaptionPassword: {
    color: theme.colors.primary,
    fontSize: 11
  },
  textCaptionError: {
    color: theme.colors.secondary,
    fontSize: 11
  },
  textCaptionSuccess: {
    color: theme.colors.success,
    fontSize: 11
  },
  caption: {
    display: 'flex',
    textAlign: 'center'
  }
}));
